<template>
  <v-row no-gutters>
    <v-col cols="12" sm="12">
      <v-container class="px-0" fluid :key="render">
        <v-row align="center" class="switch-row">
          <v-col class="label-col">
            <span class="meeting-label">{{ $t('admin.lblVotingAuditorsConsent') }}</span>
          </v-col>
          <v-col cols="auto" class="switch-col">
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                  <span 
                    v-bind="attrs"
                    v-on="on"
                    >{{ $t('admin.lblOff') }}</span>
              </template>
              <span>Voting/Auditor's Consent Email Notification Will be Off</span>
            </v-tooltip>
            <v-switch
            v-model="isVotingAuditorsConsent"
            @change="handleVotingSwitchChange"
            color="primary"
            ></v-switch>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                  <span 
                    v-bind="attrs"
                    v-on="on"
                    >{{ $t('admin.lblOn') }}</span>
              </template>
              <span>Voting/Auditor's Consent Email Notification Will be Sent</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row align="center" class="switch-row" >
          <v-col class="label-col">
            <span class="meeting-label">{{ $t('admin.lblSurveySubmission') }}</span>
          </v-col>
          <v-col cols="auto" class="switch-col">
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                  <span 
                    v-bind="attrs"
                    v-on="on"
                    >{{ $t('admin.lblOff') }}</span>
              </template>
              <span>Survey Submission Notification Will be Off</span>
            </v-tooltip>
            <v-switch
            v-model="isSurveySubmission"
            @change="handleSurveySwitchChange"
            color="primary"
            ></v-switch>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                  <span 
                    v-bind="attrs"
                    v-on="on"
                    >{{ $t('admin.lblOn') }}</span>
              </template>
              <span>Survey Submission Notification Will be Sent</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { createUUID } from "/src/utils/util";

export default {
  name: "ActionNotification",
  props: {
      setting: {
          type: Object,
          required: true,
      },
    },
  data() {
    return {
      render: 0,
      isVotingAuditorsConsent: false,
      isSurveySubmission: false,
      displayMessage: false,
      messageType: "",
      message: "",
      tenantId: localStorage.getItem("tenantId") || "",
    };
  },
  async created() {},
  mounted() {
    this.setConfig();
  },
  computed: {
    ...mapGetters({
        tenantSettingConfig: "tenant/tenantSettingConfig",
        tenantSettingTypes: "tenant/tenantSettingTypes",
    }),
  },
  methods: {
    ...mapActions({
          updateTenantConfig: "tenant/updateTenantConfig",
          createTenantConfig: "tenant/createTenantConfig",
      }),
      async setConfig() {
        const config = this.setting;
        if (config) {
          await this.onTenantConfigNameChange(config);
        }
      },
      async onTenantConfigNameChange(config) {
        try {
          const results = this.tenantSettingTypes(config.configname);
          if (results.length == 0) {
            this.isVotingAuditorsConsent = false;
            this.isSurveySubmission = false;  
          } else {
            this.isVotingAuditorsConsent = results.voting_auditors_consent;
            this.isSurveySubmission = results.survey_submission;
          }
        } catch (error) {
          console.log(error, "API error");
        }
      },
      async handleVotingSwitchChange(value) {
        await this.updateConfiguration("voting_auditors_consent", value, this.setting.configname);
      },
    async handleSurveySwitchChange(value) {
      await this.updateConfiguration("survey_submission", value);
    },
    async updateConfiguration(key, status) {
      try {
        this.Loaderloading = true;

        const allowedKeys = ["voting_auditors_consent", "survey_submission"];
        if (!allowedKeys.includes(key)) {
          console.warn(`Invalid configuration key: ${key}`);
          return;
        }

        const configName = this.setting.configname;
        const tenantConfig = this.tenantSettingConfig(configName);
        let setting;

        if (tenantConfig?.id) {
          // Update existing config
          setting = {
            id: tenantConfig.id,
            tenantid: tenantConfig.tenantid,
            configname: configName,
            [configName]: {
              voting_auditors_consent: tenantConfig[configName]?.voting_auditors_consent ?? false,
              survey_submission: tenantConfig[configName]?.survey_submission ?? false,
              [key]: status, // update the selected field
            },
          };

          await this.updateTenantConfig(setting);
        } else {
          // Create new config if it doesn't exist
          setting = {
            id: createUUID(),
            tenantid: this.tenantId,
            configname: configName,
            [configName]: {
              voting_auditors_consent: false,
              survey_submission: false,
              [key]: status,
            },
          };

          await this.createTenantConfig(setting);
        }

        this.$eventHub.$emit("onMessageDisplay", {
          message: this.$t("admin.updateTenantConfigMsg"),
          messageType: "success",
        });
      } catch (error) {
        this.$eventHub.$emit("onMessageDisplay", {
          message: this.$t("admin.updateTenantConfigError"),
          messageType: "error",
        });
      } finally {
        this.Loaderloading = false;
      }
    },

    async updateConfigurationOldff(key, status) {
      try {
        this.Loaderloading = true;

        const allowedKeys = ["voting_auditors_consent", "survey_submission"];
        if (!allowedKeys.includes(key)) {
          console.warn(`Invalid configuration key: ${key}`);
          return;
        }

        const tenantConfig = this.tenantSettingConfig(this.setting.configname);
        let setting;

        if (tenantConfig?.id) {
          // Update existing config
          setting = {
            id: tenantConfig.id,
            tenantid: tenantConfig.tenantid,
            configname: tenantConfig.configname,
            voting_auditors_consent: tenantConfig.voting_auditors_consent,
            survey_submission: tenantConfig.survey_submission,
            [key]: status, // safely update the target field
          };

          await this.updateTenantConfig(setting);
        } else {
          // Create new config if not exists
          setting = {
            id: createUUID(),
            tenantid: this.tenantId,
            configname: this.setting.configname,
            voting_auditors_consent: false,
            survey_submission: false,
            [key]: status, // safely set new value
          };

          await this.createTenantConfig(setting);
        }

        this.$eventHub.$emit("onMessageDisplay", {
          message: this.$t("admin.updateTenantConfigMsg"),
          messageType: "success",
        });
      } catch (error) {
        this.$eventHub.$emit("onMessageDisplay", {
          message: this.$t("admin.updateTenantConfigError"),
          messageType: "error",
        });
      } finally {
        this.Loaderloading = false;
      }
    },

    async updateConfigurationOld(key, status) {
            try {
                const tenantConfig = this.tenantSettingConfig(this.setting.configname);
                if (tenantConfig && tenantConfig.id) {
                  const setting = {
                        id: tenantConfig.id,
                        tenantid: tenantConfig.tenantid,
                        configname: tenantConfig.configname,
                        voting_auditors_consent: tenantConfig.voting_auditors_consent,
                        survey_submission: tenantConfig.survey_submission,
                    };
                    if(setting[key]){
                      setting[key] = status
                    }
                    this.Loaderloading = true;
                    await this.updateTenantConfig(setting);
                    this.Loaderloading = false;
                    this.$eventHub.$emit("onMessageDisplay", {
                      message: this.$t("admin.updateTenantConfigMsg"),
                      messageType: "success",
                    });
                } else {
                    const setting = {
                        id: createUUID(),
                        tenantid: this.tenantId,
                        configname: this.setting.configname,
                        voting_auditors_consent: false,
                        survey_submission: false,
                    };
                    if(setting[key]){
                      setting[key] = status
                    }
                    this.createTenantConfig(setting);
                    this.$eventHub.$emit("onMessageDisplay", {
                      message: this.$t("admin.updateTenantConfigMsg"),
                      messageType: "success",
                    });
                }
            } catch (error) {
              console.log(error, 'API error');
                this.Loaderloading = false;
            }
        },
  },
};
</script>

<style scoped>
.switch-row {
  padding: 0px 40px;
  width: inherit;
  height: 38px;
}

.switch-col {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 20px;
}

.label-col {
  flex: 1;
  padding-left: 16px;
}

.meeting-label {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

:deep(.v-input--selection-controls__input) {
  margin-right: 8px;
}

:deep(.v-label) {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>